const { Pagination } = require('./pagination.js');
const { cssColors } = require('./color.js');
const bootstrap = require("bootstrap");
const French = require("flatpickr/dist/l10n/fr.js").default.fr;
//require("flatpickr/dist/themes/airbnb.css");
require("fslightbox");

const { formatRangeDate, getDate8AsInt, getDateAsInt8, getDate8AsDateObj, formatFromToPrice, formatPrice, colorsArrayToLinearGradient } = require('../../utils/utils.js');



const destination = {
    env: "preprod",
    init() {

        if(!document.querySelector('body').classList.contains('single-voyages')) return;

        const touchEvent = "ontouchstart" in window ? "touchend" : "click";
        const destinationTrip = document.querySelector("#destination-trip");
        const destinationDateRangeModal = document.querySelector("#destination-date-range-modal");
        const reservationModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('reservationModal'));
        const dateListContainer = document.querySelector("#destination-dates-list-container");
        const destinationQuantity = document.querySelector('#quantity');
        const destinationQuantityModal = document.querySelector('#quantity-modal');
        const changeEvent = new Event('change', {bubbles: true});
        const reservationModalOpenLinks = document.querySelectorAll('.reservation-modal-open');
        const destinationDateRangeModalReset = document.querySelector('#destination-date-range-modal-reset');
        const tripColors = cssColors;
        const quantityInputs = document.querySelectorAll('.quantity-input');
        const stickyReservation = document.querySelector('.sticky-reservation');
        const reservationForm = document.querySelector('#reservation-form');
        var destFlatpckrModal;

        const datesWithTime = getAllDatesTime(dates);

        const optionsFlatpckr = {
            time_24hr: true,
            mode: 'range',
            "locale": French,
            dateFormat: "d/m/Y",
            ariaDateFormat: "d/m/Y",
            showMonths: 1,
            inline: true,
            minDate: new Date(),
            defaultDate: [],
            onOpen: (e) => { },
            onChange: (e) => {
                initPagination(filterDates(datesWithTime));
            },
            onDayCreate: (dObj, dStr, fp, dayElem) => {
                let colors = [];
                datesWithTime.forEach(d => {
                    if (d.startDatetime <= +dayElem.dateObj && d.endDatetime >= +dayElem.dateObj) {
                        colors.push(d.color);
                        dayElem.classList.add('line');
                        const gradient = colorsArrayToLinearGradient(colors);
                        dayElem.style.setProperty('--lineColor', gradient);
                    }
                })
            },
        }


        if (destinationDateRangeModal) {
            destFlatpckrModal = flatpickr(destinationDateRangeModal, optionsFlatpckr);

            destinationDateRangeModalReset.addEventListener(touchEvent, (e) => {
                e.preventDefault();
                destFlatpckrModal.clear();
            })
        }

        if (reservationModalOpenLinks.length) {
            reservationModalOpenLinks.forEach(l => {
                l.addEventListener(touchEvent, (e) => {
                    e.preventDefault();
                    openMoreDates();
                })
            })
        }

        if(stickyReservation){
            stickyReservation.querySelector('.btn-open-reservation').addEventListener(touchEvent, (e)=> {
                e.stopPropagation();
                stickyReservation.classList.toggle('active');
            })
        }
        

        if(quantityInputs.length){
            quantityInputs.forEach(inputCont=>{
                const input = inputCont.querySelector('input');
                inputCont.querySelector('.btn-minus').addEventListener(touchEvent, (e) => {
                    e.preventDefault();
                    if(input.min && input.min >= input.value) return;
                    input.value --;
                    input.dispatchEvent(changeEvent);
                });
                inputCont.querySelector('.btn-plus').addEventListener(touchEvent, (e) => {
                    e.preventDefault();
                    if(input.max && input.max <= input.value) return;
                    input.value ++;
                    input.dispatchEvent(changeEvent);
                });

            })
        }

        if(destinationQuantity && destinationQuantityModal){
            destinationQuantity.addEventListener('change', (e)=>{
                destinationQuantityModal.value = destinationQuantity.value;
                processQuantity();
            })
            destinationQuantityModal.addEventListener('change', (e)=>{
                destinationQuantity.value = destinationQuantityModal.value;
                processQuantity();
            })
        }
        
        if(reservationForm){
            reservationForm.addEventListener('submit', (e)=>{

                if(!destinationQuantity.value || !destinationTrip.value) e.preventDefault();

                if (document.querySelector(".destination-reservation .destination-price")){
                    let quantity = e.target.quantity.value;
                    let price = document.querySelector(".destination-reservation .destination-price").innerHTML.replace(/\s/g, '').replace('€', '');
                    let id = e.target.destination.value;

                    if (typeof fbq !== 'undefined') {  
                        console.log ('Is defined fbq');                  
                        fbq('track', 'AddToCart', {
                            content_type: 'product',
                            contents: [
                            {
                                id: id, 
                                quantity: quantity
                            }
                            ],
                            currency: 'EUR',
                            value: price*quantity
                        });
                        console.log ('Is sent fbq');                  

                    
                    }

                    if (typeof gtag !== 'undefined') {       
                        console.log ('Is defined gtag');                  
             
                        gtag("event", "add_to_cart", {
                            currency: "EUR",
                            value: price*quantity,
                            items: [
                            {
                                item_id: id,
                                price: price,
                                quantity: quantity
                            }
                            ]
                        });
                        console.log ('Is sent gtag');                  

                    }
                    //e.preventDefault();
                    //return;
                }
            })
        }


        initPagination(filterDates(datesWithTime));


        function processQuantity(){
            // initOptions(destinationQuantity.value);
            initPagination(filterDates(datesWithTime));
        }


        function openMoreDates() {
            reservationModal.show();
        }


        function filterDates(datesUnfiltered) {
            const startDate = destFlatpckrModal && destFlatpckrModal.selectedDates[0] ? parseInt(getDateAsInt8(destFlatpckrModal.selectedDates[0])) : 0;
            const endDate = destFlatpckrModal && destFlatpckrModal.selectedDates[1] ? parseInt(getDateAsInt8(destFlatpckrModal.selectedDates[1])) : 99999999;
            const quantity = destinationQuantityModal && destinationQuantityModal.value ? parseInt(destinationQuantityModal.value) : 1;

            datesUnfiltered.sort((a, b) => {
                return (a.startDate - b.startDate) > 0 ? 1 : -1;
            });
            return datesUnfiltered.filter(d => d.startDate >= startDate && d.endDate <= endDate /*&& d.quantity >= quantity*/);
        }

        function initPagination(datesFiltered) {
            new Pagination(
                datesFiltered,
                8,
                dateListContainer,
                loadItem
            ).init();
        }

        function initOptions(){
            let selectNewOption = false;
            if(!destinationTrip) return;
            const options = destinationTrip.querySelectorAll('option');
            if(options.length > 0)
            options.forEach((option)=>{
                option.disabled = parseInt(option.dataset.quantity) < parseInt(destinationQuantity.value) ? true : false;
                if(option.disabled && option.selected) {
                    selectNewOption = true;
                    option.selected = false;
                }
            })
            destinationTrip.value = selectNewOption || !destinationTrip.value  ? getNextAvailableDate(options) : destinationTrip.value;
        }

        function getNextAvailableDate(options){
            let r = null;
            options.forEach(option => {
                if(!option.disabled) return r = option.value;
            })
            return r;
        }


        function loadItem(data) {
            if (!data) {
                const empty = document.createElement('div');
                empty.textContent = 'Aucun voyage ne correspond à ces filtres';
                return empty;
            }

            const item = document.querySelector(".destination-dates-list-item.clone").cloneNode(true);
            item.classList.remove("clone");
            item.querySelector('.list-item-dates').textContent = formatRangeDate([data.startDate, data.endDate]);
            item.querySelector('.list-item-price').textContent = formatFromToPrice(data.price);
            item.addEventListener(touchEvent, () => {
                destinationTrip.value = data._id;
                destinationQuantity.value = destinationQuantityModal.value;
                reservationModal.hide();
            })
            return item;
        }


        function getAllDatesTime(dates) {
            const newDates = dates.map(d => {
                const startDate = getDate8AsDateObj(d.startDate).getTime();
                const endDate = getDate8AsDateObj(d.endDate).getTime();
                const color = tripColors[0];
                tripColors.shift();
                return { ...d, startDatetime: startDate, endDatetime: endDate, color: color }
            });
            return newDates;
        }



        function stickyReservationHeight() {
            document.querySelector('#destination').style.setProperty('--reservation-height', `calc(0.5rem + ${stickyReservation.clientHeight}px)`);
          }
          
        window.addEventListener('resize', stickyReservationHeight);
          
        document.addEventListener('DOMContentLoaded',()=>{
            stickyReservationHeight();
        })
          



    },
};

module.exports = destination;